import { Table } from 'antd';
import { columns } from './columns';

export default function CustomTree({
  treeData,
  onPermissionChange,
  checkedKeys,
  onCheck,
}: {
  treeData: any;
  expandedKeys: any;
  onExpand: (key: any, expanded: boolean) => void;
  onPermissionChange: (
    key: any,
    permissionType: string,
    checked: boolean,
  ) => void;
  checkedKeys: any;
  onCheck: (key: any, checked: boolean) => void;
}) {
  return (
    <Table
      dataSource={treeData}
      columns={columns({ checkedKeys, onCheck, onPermissionChange })}
      pagination={false}
    />
  );
}
